import { StyleSheet } from "@react-pdf/renderer";

export default StyleSheet.create({
  card: {
    width: "100%",
    backgroundColor: "#ffffff",
    borderTopLeftRadius: "2pt",
    borderTopRightRadius: "2pt",
    borderBottomRightRadius: "2pt",
    borderBottomLeftRadius: "2pt",
    padding: "20pt",
    marginBottom: "20pt"
  },
  "card-title": {
    fontFamily: "Helvetica",
    fontStyle: "normal",
    fontWeight: "medium",
    fontSize: "14pt",
    color: "#292d37",
    textTransform: "uppercase",
    textAlign: "left"
  },
  "preset-variable-list": {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    alignContent: "flex-start",
    alignItems: "flex-start",
    flexWrap: "wrap",
    padding: "14pt 0"
  },
  "group-container": {
    display: "flex",
    width: "100%"
  },
  operand: {
    fontFamily: "Helvetica",
    fontStyle: "normal",
    fontWeight: "medium",
    fontSize: "14pt",
    height: "36pt",
    letterSpacing: "0.01pt",
    textTransform: "uppercase",
    color: "#585A61",
    padding: "8pt"
  },
  group: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexWrap: "wrap",
    backgroundColor: "#d3e2f9",
    borderTopLeftRadius: "3pt",
    borderTopRightRadius: "3pt",
    borderBottomRightRadius: "3pt",
    borderBottomLeftRadius: "3pt",
    padding: "10pt 10pt 0 10pt",
    marginBottom: "10pt"
  },
  "group-operand-container": {
    // height: "36pt",
    width: "35pt",
    padding: "8pt"
  },
  "group-operand": {
    fontFamily: "Helvetica",
    fontStyle: "normal",
    fontWeight: "medium",
    fontSize: "10pt",
    height: "16pt",
    letterSpacing: "0.01pt",
    textTransform: "uppercase",
    color: "#585A61"
  },
  "variable-item-container": {
    backgroundColor: "#EEF5FF",
    padding: "8pt",
    marginBottom: "10pt"
  },
  "variable-item": {
    fontFamily: "Helvetica",
    fontStyle: "normal",
    fontWeight: "regular",
    fontSize: "13pt",
    height: "16pt",
    letterSpacing: "0.01pt",
    color: "#3965DE"
  }
});
